<template>
  <div class="change-password">
    <!-- 标题 -->
    <div style="padding: 10px;">
      <img :src="protectEasyLogo" style="width: 115px;">
    </div>
    <!--修改密码  -->
    <div class="change-password-content">
      <Form ref="formValidatChangePassword" :model="formValidatChangePassword" :rules="ruleValidate">
        <h3 class="change-password-title">{{ $t('common.changePassword') }}</h3>
        <!-- 密码 -->
        <FormItem prop="password" class="change-password-user">
          <Icon type="md-lock" class="change-password-icon"/>
          <input v-model="formValidatChangePassword.password" :label="$t('permission_configuration_management.user.password')" type="password" autocomplete="new-password"/>
        </FormItem>
        <!-- 确认密码 -->
        <FormItem prop="confirmPassword" class="change-password-user">
          <Icon type="md-lock" class="change-password-icon"/>
          <input v-model="formValidatChangePassword.confirmPassword" :label="$t('permission_configuration_management.user.confirmPassword')"  type="password" autocomplete="new-password"/>
        </FormItem>
        <Button type="primary" @click="changePassword('formValidatChangePassword')">{{ $t('alarms.common.nextStep') }}</Button>
      </Form>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      const pwdValidate = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('permission_configuration_management.user.passwordRequired')));
        } else {
          callback();
        }
      };
      const pwdCheckValidate = (rule, value, callback) => {
        if (this.formValidatChangePassword.password != '' && value == '') {
          callback(new Error(this.$t('permission_configuration_management.user.confirmPasswordRequired')));
        } else if (this.formValidatChangePassword.password != value) {
          callback(new Error(this.$t('permission_configuration_management.user.passwordMismatch')));
        } else {
          callback();
        }
      };
      return {
        protectEasyLogo: require('../../../../../static/images/silverlining-logo.png'),
        formValidatChangePassword: {
          password: '',
          passwordAgain: ''
        },
        ruleValidate: {
          password: [
            {required: true, validator: pwdValidate, trigger: 'blur'},
            {
              message: this.$t('permission_configuration_management.user.passwordRule'),
              pattern: '^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$',
              trigger: 'blur'
            }
          ],
          confirmPassword: [
            {required: true, validator: pwdCheckValidate, trigger: 'blur'},
            {
              message: this.$t('permission_configuration_management.user.passwordRule'),
              pattern: '^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    mounted: function () {
      // 接收忘记密码页面传来的参数
      this.verificationCode = this.$route.query.verificationCode;
      this.email = this.$route.query.email;
    },
    methods: {
      // 修改密码
      changePassword: function (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.user.changePassword({
              "verificationCode": this.verificationCode,
              "password": this.formValidatChangePassword.password,
              "email":this.email
            })
            .then(res => {
              this.$Message.success(this.$t('permission_configuration_management.user.changeSuccessExclaim'));
              // this.$router.replace('/login');
              window.location.href = `${global.SSO_PORTAL}/cmc/#/login`
            })
          } else {
            this.$Message.error(this.$t('permission_configuration_management.user.changeFailExclaim'));
          }
        })
      }
    }
  }
</script>
<style scoped>
  .change-password {
    position: fixed;
    left: 0;
    right: 0;
    background-color: #2d3a4b;
    top: 0;
    bottom: 0;
  }

  .change-password-content {
    width: 448px;
    height: 330px;
    margin-top: -165px;
    margin-left: -181px;
    position: fixed;
    top: 45%;
    left: 47%;
  }

  .change-password-title {
    font-size: 26px;
    color: #eee;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }
  .change-password-user {
    width: 448px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
    line-height: 52px;
    height: 52px;
    font-size: 14px;
    margin-bottom: 18px;
  }
  .change-password-icon {
    padding-left: 13px;
    color: #889aa4;
    font-size: 18px;
    margin-top: -4px;
  }

  .change-password-user input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: #eee;
    height: 47px;
    width: 395px;
    outline: none;
  }

  .change-password-content Button {
    width: 100%;
    height: 40px;
    font-size: 14px;
    margin-bottom: 22px;
  }
  .change-password-content >>> .ivu-select-selection {
    background: transparent;
    border: 0;
    box-shadow: none;
  }

  .change-password-content >>> .ivu-select-selected-value {
    color: #fff;
  }

  .change-password-content >>> .ivu-select-arrow {
    position: absolute;
    top: 50%;
    right: 8px;
    line-height: 1;
    transform: translateY(-50%);
    font-size: 14px;
    color: #808695;
    transition: all .2s ease-in-out;
  }

  .change-password-content >>> .ivu-select-placeholder {
    color: #707070;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/ChangePassword.vue